###
  Tree widget
###

class INTENT.widgets.TreeControl

  @ATTR_NAME: "data-widget-tree-control"

  constructor: (@el) ->
    @s = @.constructor

    @advertiser_id = $('#edit-campaign-form').attr('data-advertiser-id')
    @object_id = $('#edit-campaign-form').attr('data-object-id')
    @for_mobile = $('#edit-campaign-form').attr('data-is-mobile')
    @json_node = @el.closest('[data-widget-targeting-type]').attr('data-widget-targeting-type')

    @treeRoot = @el.find "[data-tree-container] > ul"

    @segments_checkbox = @el.parents('.ajax-load').find ".on-off"
    @segments_checkbox.on 'switchChange.bootstrapSwitch', @changeSegmentList

    if @treeRoot.length > 0
      @initSegmentsTree()

  getSegmentList: =>
    self = @
    tree_container = @el.find('[data-tree-container]')
    Loader.show({target: "[data-widget-tree-control]"})

    data =
      advertiser_id: @advertiser_id
      object_id: @object_id
      json_node: @json_node
      for_mobile: @for_mobile

    request = $.ajax({
      url: "/ajax/get_segments",
      data: data
      type: "get",
      dataType: "html"
    })

    request.done (data) ->
      self.el.addClass('ajax-load')
      tree_container.html(data)
      Loader.hide({target: "[data-widget-tree-control]"})
      self.initSegmentsTree()

  changeSegmentList: (e, state) =>
    @ajaxload = @el.hasClass('ajax-load')

    if state == true && @ajaxload == false
      @getSegmentList()


  initSegmentsTree: () =>
    @search = @el.find "input.search"
    @info = @el.next '[data-tree-info]'
    @treeContainer = @el.find "[data-tree-container]"
    @treeRoot = @el.find "[data-tree-container] > ul"
    @el.css({height:'250px'})

    @instance = new treefilter(@treeRoot, {
      searcher: @search,
      info: @info,
      multiselect: true
    });